import { Box, Card, Chip, Typography, useTheme } from '@mui/material';
import React from 'react';
import { CardContentStyled } from './style';
// import { CustomChip } from '../CustomChip';
import CustomTooltip from '../CustomTooltip';

// Service card for Services page
function ServiceCard({ serviceData, ButtonsUI, onClick = () => {}, hideTooltip}) {
    const theme = useTheme();
    return (
        <Card
            sx={{
                minWidth: 300,
                maxWidth: 300,
                minHeight: { xs: '0px', sm: 210 },
                maxHeight: 210,

                overflow: 'auto',
                boxShadow: 'none',
                border: `1px solid ${theme.palette.border.neutralPrimary}`,
                borderRadius: '12px',
                position: 'relative',

                cursor: onClick ? 'pointer' : 'text',

                '@media (max-width:799px)': {
                    minWidth: '100%',
                    maxWidth: '100%',
                },

                [theme.breakpoints.down('sm')]: {
                    minWidth: '100%',
                    maxWidth: '100%',
                    maxHeight: 'unset',
                }
            }}
            onClick={() => onClick(serviceData.id)}
        >
            <CardContentStyled>
                {/* <CardIcon bgColor={'#91DC8B'}></CardIcon> */}
                <Box>
                    <Typography
                        gutterBottom
                        variant="paraText1"
                        component="h2"
                        color={'text.primary'}
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 3, // Limit to 3 lines
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                        title={serviceData.name}
                    >
                        {serviceData.name}
                    </Typography>
                    <Typography gutterBottom variant="paraText2" component="div" color={'text.secondary'}>
                        {serviceData.companyName}
                    </Typography>
                    {/* <CustomChip label={serviceData.companyName} color="primary" variant="outlined" /> */}
                    <Box sx={{ minHeight: { xs: '0px', sm: 80 }, mt: theme.typography.generic.xSmall, marginBottom: { xs: theme.typography.generic.xxxxxLarge, sm: theme.typography.generic.none } }}>
                        {!hideTooltip && (
                            <CustomTooltip title={serviceData.description}>
                                <Typography
                                    gutterBottom
                                    variant="paraText4"
                                    color="text.secondary"
                                    sx={{
                                        display: '-webkit-box',
                                        WebkitLineClamp: 3, // Limit to 3 lines
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        
                                        [theme.breakpoints.down('sm')]:{
                                            display: 'block'
                                        }
                                    }}
                                >
                                    {serviceData.description}
                                </Typography>
                            </CustomTooltip>
                        )}
                        {hideTooltip && (
                            <Typography
                                title={serviceData.description}
                                gutterBottom
                                variant="paraText4"
                                color="text.secondary"
                                sx={{
                                    display: '-webkit-box',
                                    WebkitLineClamp: 3, // Limit to 3 lines
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',

                                    [theme.breakpoints.down('sm')]:{
                                        display: 'block'
                                    }
                                }}
                            >
                                {serviceData.description}
                            </Typography>
                        )}
                    </Box>
                    {ButtonsUI && <Box>{ButtonsUI}</Box>}
                    {serviceData?.status && (
                        <Box
                            sx={{
                                position: { xs: 'unset', sm: 'absolute' },
                                bottom: '12px',
                            }}
                        >
                            {serviceData?.status === 'Not Started' && <Chip label="Not Started" variant="outlined" />}
                            {serviceData?.status === 'In Progress' && <Chip label="In Progress" variant="outlined" color="warning" />}
                            {serviceData?.status === 'Submitted' && <Chip label="Submitted" variant="outlined" color="success" />}
                        </Box>
                    )}
                </Box>
            </CardContentStyled>
        </Card>
    );
}

export default ServiceCard;
